export default __webpack_public_path__ + "slicer-bro.ec3f19701620eea01da4c00a18204b50.webp";